import { atom } from "jotai";
import { Gender, NameOptions, NameResult, UnlockedName } from "../types";
import { FREE_TRIES_TIMES } from "../constants/common";

interface UserAtom {
  isLogin: boolean;
  email: string;
  nickname: string;
}

export type AuthMode = "login" | "register" | "reset-password";

interface AuthAtom {
  modalVisible: boolean;
  mode: AuthMode;
}

// 登录状态原子
export const authAtom = atom<AuthAtom>({
  modalVisible: false,
  mode: "login",
});

// 用户信息原子
export const userAtom = atom<UserAtom>({
  isLogin: false,
  email: "",
  nickname: "",
});

// 名字生成结果原子
export const nameResultsAtom = atom<NameResult[]>([]);

// 表单状态原子
export interface FormState {
  firstName: string;
  lastName: string;
  gender: Gender;
  length: number;
  options: NameOptions;
}

export const formStateAtom = atom<FormState>({
  firstName: "",
  lastName: "",
  gender: "male",
  length: 3,
  options: {
    styles: [],
    themes: [],
    meanings: [],
    phonetics: [],
  },
});

// 检测是否有重复名字的派生原子
export const hasDuplicateNameAtom = atom((get) => {
  const results = get(nameResultsAtom);
  if (results.length <= 1) return false;

  // 获取最新生成的名字
  const latestName = results[0]?.chineseName;

  // 检查是否在之前的结果中存在
  return results.slice(1).some((result) => result.chineseName === latestName);
});

// 已解锁的原始名称原子
export const unlockedNamesAtom = atom<UnlockedName[]>([]);

// 获取剩余尝试次数的派生原子
export const triesLeftAtom = atom((get) => {
  // 原始名字
  const formState = get(formStateAtom);
  const originalName = `${formState?.firstName || ""} ${
    formState?.lastName || ""
  }`;
  if (!originalName) return FREE_TRIES_TIMES;

  // 当前原始名字已尝试次数
  const currentUsed = get(nameResultsAtom).filter(
    (item) => `${item.firstName} ${item.lastName}` === originalName
  ).length;
  // 付费解锁的名字
  const unlockedNames = get(unlockedNamesAtom);
  // 当前原始名字剩余尝试次数
  const unlockedName = unlockedNames.find(
    (name) => `${name.firstName} ${name.lastName}` === originalName
  );
  let triesLeft: number;
  if (unlockedName) {
    triesLeft = unlockedName.triesAmount + FREE_TRIES_TIMES;
  } else {
    // 没有记录，也就是未付费
    // 使用免费尝试的次数
    triesLeft = FREE_TRIES_TIMES;
  }
  return triesLeft - currentUsed;
});
